import { render, staticRenderFns } from "./admindashboard.vue?vue&type=template&id=439ed76c&"
import script from "./admindashboard.vue?vue&type=script&lang=js&"
export * from "./admindashboard.vue?vue&type=script&lang=js&"
import style0 from "./admindashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports